import React from 'react'
import {Link} from 'react-router-dom'
import {Button ,Stack,Typography} from '@mui/material'
import { exercisesOptions,fetchData } from '../utils/fetchData'
import { fontSize, fontWeight, textTransform } from '@mui/system'


const ExerciseCard = ({exercise}) => {
  
  return (
    <Link to={`exercise/${exercise.id}`} className="exercise-card">

       <img src={exercise.gifUrl} alt={exercise.name} loading="lazy"/>
        <Stack direction="row">
          <Button sx={{ml:'21px',color:'#fff',backgroundColor:'#ffa9a9',borderRadius:'20px',fontSize:'14px', textTransform : 'capitalize',textDecoration: 'none'}}>
            {exercise.bodyPart}
          </Button>
          <Button sx={{ml:'21px',color:'#fff',backgroundColor:'#fcc787',borderRadius:'20px',fontSize:'14px', textTransform : 'capitalize',textDecoration: 'none'}}>
            {exercise.target}
          </Button>
        </Stack>
       <Typography ml="21px" color="#000" fontWeight="bold" mt="11px" pb="10px" textTransform="capitaliz" fontSize='22px'>
          {exercise.name}
       </Typography>
    </Link>
  )
}

export default ExerciseCard